module.exports = __webpack_public_path__ + "img/patrick-perkins-ETRPjvb0KM0-unsplash.7f72e33e.jpg";